<template>
  <div>
    <common-navbar v-if="$isFlag" :is-home-bar="true" />
    <van-loading v-if="loading" size="40px" vertical color="#0094ff" text-size="17px" class="jumpClass">正在跳转至支付宝</van-loading>
    <!-- 申诉成功提示 -->
    <div v-else>
      <div v-show="isFace == 1" class="appealResult">
        <img src="~assets/images/accountCenter/success@2x.png" alt="">
        <p>申诉成功</p>
      </div>
      <p v-show="isFace == 0" class="notice">{{ noticeMsg }}</p>
      <div v-show="isFace == 2" class="appealResult">
        <img src="~assets/images/accountCenter/fail@2x.png" alt="">
        <p>人脸认证失败</p>
        <div class="btn">
          <van-button
            v-if="isShowAppealInfo"
            round
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="handleWrite"
          >手动填写申诉信息</van-button>
          <van-button
            round
            block
            type="info"
            color="#616edf"
            :disabled="disabled"
            class="formClass_btn"
            @click="faceAgain"
          >继续人脸申诉</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonNavbar from '@/views/accountCenter/common/commonNavbar'
import Cookies from 'js-cookie'
import * as api from '@/api/account-self-manage/accountAppeal'

export default {
  name: 'Index',
  components: { commonNavbar },
  data() {
    return {
      disabled: false,
      show: true,
      loading: true,
      isFace: 0,
      noticeMsg: '',
      isShowAppealInfo: false // 是否隐藏【手动填写申诉信息】入口
    }
  },
  created() {},
  mounted() {
    const { t, u, f } = this.$route.query
    const faceUrl = this.$store.state.accountSelf.faceUrl
    console.log(faceUrl, t, u, f, 'awdwa')
    if (f && f == '1') {
      this.isShowAppealInfo = false
    }
    if (t && u) {
      Cookies.set('APPEAL_TOKEN', t, { domain: 'leiting.com' })
      Cookies.set('APPEAL_UID', u, { domain: 'leiting.com' })
      this.loading = false
      this.checkFace()
    } else {
      if (faceUrl) {
        this.jumpStationUrl(faceUrl)
        return
      }
      this.$msg('链接参数有误')
      this.noticeMsg = '链接参数有误'
      this.loading = false
    }
  },
  methods: {
    jumpStationUrl(url) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.style.target = '_blank'
      elink.href = url
      this.$store.dispatch('accountSelf/saveFaceUrl', '')
      setTimeout(() => {
        this.loading = false
        this.noticeMsg = '请在支付宝返回的页面进行操作'
      }, 3000)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },
    handleWrite() {
      this.$router.push('/accountCenter/accountSelf/accountAppeal?stateKey=5')
    },
    checkFace() {
      api.check_face().then(res => {
        if (res.status == 0) {
          this.$ssd.track('leiting_appeal_faceOk')
          this.isFace = 1
        } else {
          this.isFace = 2
          this.$ssd.track('leiting_appeal_faceFail')
        }
      })
    },
    faceAgain() {
      api.get_face().then(res => {
        if (res.status == 0) {
          this.$msg('正在跳转至支付宝')
          this.jumpStationUrl(res.data)
        } else if (res.status == 50001 || res.status == 50003) {
          // 50001：人脸次数达到上限 50003：强制人脸次数达到上限，不允许人工申诉
          this.$msg(res.message)
          this.disabled = true
        } else {
          this.$msg(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~assets/css/reset.styl';
</style>
<style lang="stylus" scoped>
// h5
.notice{
    color: black;
    font-size: .3rem;
    margin-top: 4rem;
    text-align: center;
}
.jumpClass{
  width: 100%;
    z-index: 99;
    z-index: 999;
    height: 100%;
    position: absolute;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.appealResult {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .btn {
    display: flex;
    justify-content: space-between;

    .formClass_btn {
      width: 3.14rem;
      margin-right: 0.2rem;
      margin-top: 0.5rem;
    }
  }

  img {
    display: block;
    margin-top: 1rem;
    height: 3rem;
  }

  p {
    margin: 0.2rem;
    font-size: 0.34rem;
  }

  p:nth-child(2) {
    color: black;
  }

  p:nth-child(3) {
    color: #40BC40;
    position: relative;
  }

  p:nth-child(4) {
    font-size: 0.24rem;
    color: #B2B2B2;
    padding: 0 0.4rem;
    line-height: 0.4rem;

    span {
      color: #2dadea;
    }
  }
}
</style>
